import {
  PaymentMethod,
  PaymentOption,
  PaymentType,
  ReservedPaymentOptionLabels,
} from '../../../../types/types';
import settingsParams from '../../../../components/BookingsForm/settingsParams';
import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';

export const sortPaymentOptions = (
  paymentOptions: PaymentOption[],
  settings: ControllerFlowAPI['settings'],
): PaymentOption[] => {
  const plansOptions = [
    ...paymentOptions.filter((p) => p.type === PaymentType.USE_PLAN),
    ...paymentOptions.filter((p) => p.type === PaymentType.BUY_PLAN),
  ];

  const onlineOption = paymentOptions.filter(
    (p) =>
      p.type === PaymentType.SINGLE_SESSION &&
      p.label === ReservedPaymentOptionLabels.ONLINE,
  );
  const offlineOption = paymentOptions.filter(
    (p) =>
      p.type === PaymentType.SINGLE_SESSION &&
      p.label === ReservedPaymentOptionLabels.OFFLINE,
  );

  switch (settings.get(settingsParams.defaultPaymentMethod)) {
    case PaymentMethod.ONLINE: {
      return [...onlineOption, ...offlineOption, ...plansOptions];
    }
    case PaymentMethod.OFFLINE: {
      return [...offlineOption, ...onlineOption, ...plansOptions];
    }
    case PaymentMethod.MEMBERSHIP: {
      return [...plansOptions, ...onlineOption, ...offlineOption];
    }
    default: {
      return [...onlineOption, ...offlineOption, ...plansOptions];
    }
  }
};
